/* Orthoplay CRO page behaviour. Vanilla, no dependencies. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + v;
  }

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-op-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-op-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-op-gallery-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-src');
        if (main && src) {
          main.src = src;
          main.srcset = '';
          if (btn.getAttribute('data-alt')) main.alt = btn.getAttribute('data-alt');
        }
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Buy modules (hero + final CTA share this) ---------- */
  var buyModules = document.querySelectorAll('[data-op-buy]');
  var state = { variant: null };

  buyModules.forEach(function (mod) {
    var dataEl = mod.querySelector('[data-op-variants]');
    if (!dataEl) return;
    var variants, meta;
    try {
      variants = JSON.parse(dataEl.textContent);
      meta = JSON.parse(mod.querySelector('[data-op-meta]').textContent);
    } catch (e) { return; }

    var sizeInputs = mod.querySelectorAll('input[name^="op-size"]');
    var themeInputs = mod.querySelectorAll('input[name^="op-theme"]');
    var idInput = mod.querySelector('input[name="id"]');

    function selected(inputs) {
      var found = null;
      inputs.forEach(function (i) { if (i.checked) found = i.value; });
      return found;
    }

    function resolve() {
      var size = selected(sizeInputs);
      var theme = selected(themeInputs) || (variants[0] && variants[0].option2);
      var match = variants.find(function (v) {
        return v.option1 === size && (themeInputs.length === 0 || v.option2 === theme);
      }) || variants.find(function (v) { return v.option1 === size; });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      state.variant = match;

      var priceEl = mod.querySelector('[data-op-price-now]');
      var wasEl = mod.querySelector('[data-op-price-was]');
      var saveEl = mod.querySelector('[data-op-price-save]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (wasEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          wasEl.textContent = formatMoney(match.compare_at_price);
          wasEl.hidden = false;
          if (saveEl) {
            saveEl.textContent = 'Je bespaart ' + formatMoney(match.compare_at_price - match.price);
            saveEl.hidden = false;
          }
        } else {
          wasEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }

      /* Theme swatch preview swaps the gallery main image when mapped */
      var themeImg = meta.themeImages && meta.themeImages[theme];
      var mainImg = document.querySelector('[data-op-gallery-main] img');
      if (themeImg && mainImg && mod.hasAttribute('data-op-primary')) {
        mainImg.src = themeImg;
        mainImg.srcset = '';
      }

      document.dispatchEvent(new CustomEvent('op:variant', { detail: match }));
    }

    function paint(inputs, cls) {
      inputs.forEach(function (i) {
        var label = i.closest('label');
        if (label) label.classList.toggle(cls, i.checked);
      });
    }
    function onChange() {
      paint(sizeInputs, 'is-checked');
      paint(themeInputs, 'is-checked');
      resolve();
    }
    sizeInputs.forEach(function (i) { i.addEventListener('change', onChange); });
    themeInputs.forEach(function (i) { i.addEventListener('change', onChange); });
    onChange();
  });

  /* ---------- Sticky ATC (mobile) ---------- */
  var sticky = document.querySelector('[data-op-sticky]');
  var heroForm = document.querySelector('[data-op-buy][data-op-primary] form');
  if (sticky && heroForm) {
    var label = sticky.querySelector('[data-op-sticky-label]');
    var price = sticky.querySelector('[data-op-sticky-price]');
    document.addEventListener('op:variant', function (e) {
      if (label) label.textContent = e.detail.option1 + (e.detail.option2 ? ' \u00B7 ' + e.detail.option2 : '');
      if (price) price.textContent = formatMoney(e.detail.price);
    });
    sticky.querySelector('[data-op-sticky-btn]').addEventListener('click', function () {
      var submit = heroForm.querySelector('[type="submit"]');
      if (submit) submit.click();
    });
    var hero = document.querySelector('[data-op-buy][data-op-primary]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(hero);
    }
  }

  /* ---------- Scroll to hero from secondary CTAs ---------- */
  document.querySelectorAll('[data-op-scroll-buy]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var hero = document.querySelector('[data-op-buy][data-op-primary]');
      if (hero) { e.preventDefault(); hero.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.op-reveal').forEach(function (el) { io.observe(el); });
  }
})();
